import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeTab: null,
};

export const headerSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
  },
});

export const selectActiveTab = (state) => state.header.activeTab;

export const { setActiveTab } = headerSlice.actions;

export default headerSlice.reducer;
